import React from 'react';
import { Skeleton } from '@mui/lab';

export const ConditionalLoader = ({ condition, children }) => {
  if (condition) {
    return <Skeleton>{children}</Skeleton>;
  }
  return children;
};
